if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}





function showCollectionInfoForProduct(product) {
  // Check if the product belongs to any collection
  if (!product.collections || product.collections.length === 0) {
    $('#collection-info').hide(); // Hide if no collections
    return;
  }

  // Get the first collection handle (you can loop through product.collections for multiple collections)
  const collectionHandle = product.collections[0]; // Adjust if product belongs to more than one collection
  const collection = window.collectionsMeta[collectionHandle];

  if (!collection) {
    $('#collection-info').hide(); // If collection doesn't exist, hide
    return;
  }

  // Generate HTML for collection image and title
  const imgHtml = collection.image
    ? `<img class="coll_image" src="${collection.image}" alt="${collection.title}" /> `
    : '';

  // Update collection info HTML on the product page
  $('#collection-info .coll_heading').html(imgHtml + `<span>${collection.title}</span>`);
  $('#collection-info .coll_description').text(collection.description || '');

  // Show collection info
  $('#collection-info').show();
}

$(document).ready(function() {
  // Example product object with collections (replace this with your dynamic product data)
  const product = {
    collections: ['summer-collection'] // Example collection handle (you'll dynamically populate this)
  };

  // Call function to display collection info on product page
  showCollectionInfoForProduct(product);
});
